import { useContext, useMemo } from 'react'
import { RouterProvider } from 'react-router-dom'
import { ReactAppEnv } from 'apiConfig'
import { UserContext } from '../App/UserContext'
import { AppLayout } from '../App/AppLayout'
import { createRouter } from './createRouter'

interface AppRouterProps {
  environment: ReactAppEnv
}

export const AppRouter = ({ environment }: AppRouterProps) => {
  const {
    isInternal,
    isPackagingSupplier,
    isFabricSupplier,
    isTrimSupplier,
    isAdmin,
    canImpersonate,
  } = useContext(UserContext)

  const router = useMemo(
    () =>
      createRouter(environment, AppLayout, {
        isInternal,
        isPackagingSupplier,
        isFabricSupplier,
        isTrimSupplier,
        isAdmin,
        canImpersonate,
      }),
    [
      environment,
      isInternal,
      isPackagingSupplier,
      isFabricSupplier,
      isTrimSupplier,
      isAdmin,
      canImpersonate,
    ],
  )

  return <RouterProvider router={router} />
}
